import { useEffect, useState } from "react";
import { CheckCircle2, FileText } from "lucide-react";
import { adminApi } from "../../lib/api";
import { inr } from "../landing/usePricing";

export const MySlip = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    adminApi.get("/worker/hk/slip").then((r) => setD(r.data)).catch(() => {});
  }, []);
  if (!d) return null;
  const dismiss = () => adminApi.post("/worker/hk/slip/notice-seen").then(() => setD({ ...d, notice: null })).catch(() => {});
  return (
    <>
    {d.notice && (
      <div data-testid="worker-payout-notice" className="flex flex-wrap items-center justify-between gap-3 border border-emerald-500/40 bg-emerald-500/10 p-4">
        <p className="flex items-center gap-2 text-emerald-200"><CheckCircle2 className="h-5 w-5 text-emerald-400" />
          <span><b>Payment mil gaya!</b> {inr(d.notice.amount)} for {d.notice.shifts} shift(s) has been paid on {new Date(d.notice.at).toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" })}.</span>
        </p>
        <button onClick={dismiss} data-testid="worker-payout-notice-ok" className="bg-emerald-600 px-4 py-1.5 text-sm font-semibold text-white hover:bg-emerald-700">OK</button>
      </div>
    )}
    <section data-testid="worker-slip" className="flex flex-wrap items-center justify-between gap-4 border border-white/10 bg-[#0F172A] p-5">
      <div>
        <p className="flex items-center gap-2 font-heading text-lg font-bold text-white"><FileText className="h-5 w-5 text-orange-400" />My payout slip</p>
        <p className="mt-1 text-sm text-slate-400">
          {d.shifts} shift(s) · earned <b data-testid="worker-slip-total" className="text-white">{inr(d.total)}</b> · paid <b className="text-emerald-300">{inr(d.paid)}</b> · due <b data-testid="worker-slip-due" className="text-amber-300">{inr(d.unpaid)}</b>
        </p>
      </div>
      <a href={`/slip/${d.token}`} target="_blank" rel="noreferrer" data-testid="worker-slip-open"
        className="bg-orange-500 px-5 py-2 text-sm font-semibold text-white hover:bg-orange-600">View / Download slip</a>
    </section>
    </>
  );
};
